import { LegalShell, type LegalSection } from './_shared';

const SECTIONS: LegalSection[] = [
  {
    h: 'Before anything else',
    body: (
      <p>
        Nearmirer does not verify who anyone is. Treat every new contact as a stranger — because
        they are. Anonymity protects you too: you never owe anyone your name, your number, or a
        reason.
      </p>
    ),
  },
  {
    h: 'Protect your identity',
    body: (
      <ul className="list-disc space-y-1 pl-5">
        <li>Keep your handle and bio free of your real name, workplace, or school.</li>
        <li>Don't share your phone number, socials, home area, or daily routine early.</li>
        <li>
          Your appearance blurb is visible to opted-in people nearby — keep it about your outfit,
          not identifying marks.
        </li>
      </ul>
    ),
  },
  {
    h: 'If you decide to meet',
    body: (
      <ul className="list-disc space-y-1 pl-5">
        <li>
          Stay in the public venue you're already in. Don't leave together on a first meeting.
        </li>
        <li>Tell a friend where you are and who you're meeting.</li>
        <li>Arrange your own way home.</li>
        <li>Trust your gut. You can walk away at any moment, no explanation.</li>
      </ul>
    ),
  },
  {
    h: 'Blocking and reporting',
    body: (
      <p>
        <strong>Block</strong> removes the person from your radar and closes any thread immediately
        — they're not told. <strong>Report</strong> sends the specific message you choose, and only
        that message, to our moderation team along with the reason. We review reports by hand. Use
        both freely; there is no penalty for reporting.
      </p>
    ),
  },
  {
    h: 'Appealing a moderation decision',
    body: (
      <p>
        If we warn, mute, suspend, or ban your account and you think it was a mistake, you can
        appeal. Once a sanction is in place the app shows an <strong>Appeal</strong> option; you can
        also email safety@nearmirer.com. Tell us briefly what happened. A different reviewer — not
        the moderator who made the original call — looks at every appeal, and you'll be told the
        outcome. You can have one open appeal at a time.
      </p>
    ),
  },
  {
    h: 'Warning signs',
    body: (
      <ul className="list-disc space-y-1 pl-5">
        <li>Pushing to move to another app, or for your number, right away.</li>
        <li>Pressure, guilt, or anger when you set a boundary.</li>
        <li>Asking for money, gift cards, or crypto — always a scam.</li>
        <li>Refusing to keep things in the public space you're both in.</li>
      </ul>
    ),
  },
  {
    h: 'In an emergency',
    body: (
      <p>
        If you are in immediate danger, contact your local emergency number (for example, 911 in the
        US and Canada, 112 across the EU and UK, 100/102 in India, 000 in Australia). For non-urgent
        support, look up a helpline in your country — many operate 24/7 for harassment, assault, and
        crisis support. If someone on Nearmirer is threatening you, report them and, if you feel
        unsafe, involve local authorities; we cooperate with valid legal requests.
      </p>
    ),
  },
  {
    h: 'Tell us',
    body: <p>Safety concerns that need a fast look: safety@nearmirer.com.</p>,
  },
];

export function SafetyPage() {
  return (
    <LegalShell
      title="Safety Center"
      path="/safety"
      seoDescription="How to meet people near you safely on Nearmirer — blocking, reporting, meeting in public, and support resources."
      intro={
        <p>
          Nearmirer is meant to be light and fun. These are the habits that keep it that way. Read
          them once; they take two minutes.
        </p>
      }
      sections={SECTIONS}
    />
  );
}
